import { render, staticRenderFns } from "./LeasesTabs.vue?vue&type=template&id=7b2625a3&scoped=true"
import script from "./LeasesTabs.vue?vue&type=script&lang=js"
export * from "./LeasesTabs.vue?vue&type=script&lang=js"
import style0 from "./LeasesTabs.vue?vue&type=style&index=0&id=7b2625a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2625a3",
  null
  
)

export default component.exports